module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar",
    class: _vm.getCssClass(),
    style: ('width:' + _vm.progress + '%')
  }, [_c('span', [_vm._v(_vm._s(_vm.progress) + "%")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1ab22e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/ProgressBarComponent.vue
// module id = 1345
// module chunks = 2